import React from "react";
import styles from "../index.module.css";

export function DrivingCarIcon() {
  return (
    <svg width="36" height="22" viewBox="0 0 36 22" className={styles.drivingCar}>
      <title>Driving</title>
      <line x1="5" y1="9" x2="0" y2="9" stroke="#22c55e" strokeWidth={1.5} strokeLinecap="round" className={styles.motionLine} />
      <line x1="5" y1="12" x2="1" y2="12" stroke="#22c55e" strokeWidth={1} strokeLinecap="round" className={styles.motionLine} style={{ animationDelay: "0.1s" }} />
      <line x1="5" y1="15" x2="2" y2="15" stroke="#22c55e" strokeWidth={0.8} strokeLinecap="round" className={styles.motionLine} style={{ animationDelay: "0.2s" }} />
      <path d="M6,16 L6,11 Q6,9 8,9 L10,9 L13,5 Q14,3.5 16,3.5 L22,3.5 Q24,3.5 25,5 L28,9 L30,9 Q32,9 32,11 L32,16 Q32,17.5 30.5,17.5 L28.5,17.5" fill="none" stroke="#22c55e" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5,17.5 L23.5,17.5" fill="none" stroke="#22c55e" strokeWidth={1.4} strokeLinecap="round" />
      <path d="M6,17.5 L8.5,17.5" fill="none" stroke="#22c55e" strokeWidth={1.4} strokeLinecap="round" />
      <path d="M13.5,8.8 L15,5 L22,5 L24,8.8 Z" fill="none" stroke="#22c55e" strokeWidth={1.1} strokeLinejoin="round" opacity={0.7} />
      <line x1="19" y1="5" x2="19" y2="9" stroke="#22c55e" strokeWidth={0.8} opacity={0.5} />
      <circle cx="27" cy="17.5" r="3.2" fill="none" stroke="#22c55e" strokeWidth={1.4} className={styles.wheel} style={{ transformOrigin: "27px 17.5px" }} />
      <circle cx="27" cy="17.5" r="1" fill="#22c55e" />
      <circle cx="11" cy="17.5" r="3.2" fill="none" stroke="#22c55e" strokeWidth={1.4} className={styles.wheel} style={{ transformOrigin: "11px 17.5px" }} />
      <circle cx="11" cy="17.5" r="1" fill="#22c55e" />
    </svg>
  );
}

export function ParkedCarIcon() {
  return (
    <svg width="36" height="22" viewBox="0 0 36 22">
      <title>Parked</title>
      <path d="M4,16 L4,11 Q4,9 6,9 L8,9 L11,5 Q12,3.5 14,3.5 L22,3.5 Q24,3.5 25,5 L28,9 L30,9 Q32,9 32,11 L32,16 Q32,17.5 30.5,17.5 L28.5,17.5" fill="none" stroke="#9CA3AF" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5,17.5 L23.5,17.5" fill="none" stroke="#9CA3AF" strokeWidth={1.4} strokeLinecap="round" />
      <path d="M4,17.5 L7.5,17.5" fill="none" stroke="#9CA3AF" strokeWidth={1.4} strokeLinecap="round" />
      <path d="M11.5,8.8 L13,5 L22,5 L24,8.8 Z" fill="none" stroke="#9CA3AF" strokeWidth={1.1} strokeLinejoin="round" opacity={0.7} />
      <line x1="18" y1="5" x2="18" y2="9" stroke="#9CA3AF" strokeWidth={0.8} opacity={0.5} />
      <circle cx="27" cy="17.5" r="3.2" fill="none" stroke="#9CA3AF" strokeWidth={1.4} />
      <circle cx="27" cy="17.5" r="1" fill="#9CA3AF" />
      <circle cx="9" cy="17.5" r="3.2" fill="none" stroke="#9CA3AF" strokeWidth={1.4} />
      <circle cx="9" cy="17.5" r="1" fill="#9CA3AF" />
      <rect x="14" y="8" width="8" height="6" rx="1.5" fill="#F3F4F6" stroke="#D1D5DB" strokeWidth={0.8} />
      <text x="18" y="13" textAnchor="middle" fill="#6B7280" fontSize={5} fontWeight={700}>P</text>
    </svg>
  );
}
